import api, { baseURL } from "../api"

export const deactivateUser = (userId, action) => {
	return api.patch(`/auth/${userId}/status?action=${action}`);
}

const getV2Base = () => {
	try {
		return new URL(baseURL || "").origin;
	} catch {
		return baseURL || "";
	}
};

const getAuthHeader = () => {
	const token = localStorage.getItem("ProlegionAccessToken");
	return token ? { Authorization: `Bearer ${token}` } : {};
};

// Products granted on top of the base "hiring-suite" access. The API derives the
// product from the user's role, so the payload only carries the enabled flag.
export const ADDON_PRODUCTS = ["vendor-management", "workforce-management"];

export const hasAddonProductAccess = (productAccess) =>
	(productAccess || []).some((product) => ADDON_PRODUCTS.includes(product));

export const updateUserProductAccess = (userId, enabled) => {
	return api.put(
		`${getV2Base()}/api/v2/cms/users/${userId}/product-access`,
		{ enabled },
		{ headers: getAuthHeader() }
	);
};